import request from '@/utils/request'

/**
 * 查询指定桥梁的告警设备状态
 * @param {number} bridgeId - 桥梁ID
 * @returns {Promise<{code: number, message: string, data: {bridgeId: number, hasAlertDevices: boolean, onlineDeviceCount: number, relayDeviceCount: number, screenDeviceCount: number, totalDeviceCount: number, supportedAlertTypes: string[], relayDevices: Array<{deviceId: string, deviceName: string, deviceType: string, status: string}>, screenDevices: Array<{deviceId: string, deviceName: string, deviceType: string, status: string}>}>} 桥梁告警设备状态信息
 */
export function getBridgeAlertDevices(bridgeId) {
  return request({
    url: `/alert/bridge/${bridgeId}/alert-devices`,
    method: 'get'
  })
}

